export default {
  privacy: {
    title: 'سياسة الخصوصية',
    lastUpdated: 'آخر تحديث:',
    lastUpdatedDate: '16 أكتوبر 2026',
    backToHome: '← العودة إلى الصفحة الرئيسية',
    seoDescription:
      'تعرّف على كيفية جمع Geofleet.ai لمعلوماتك واستخدامها وحمايتها، بما في ذلك تكاملات Google Workspace وGoogle Sheets وحدود الذكاء الاصطناعي/التعلم الآلي وحقوق الخصوصية الخاصة بك.',
    intro: [
      'تحترم Geofleet.ai («Geofleet» أو «نحن» أو «لنا») خصوصيتك وتلتزم بحماية المعلومات الموكلة إليها.',
      'توضح سياسة الخصوصية هذه كيف نجمع المعلومات ونستخدمها ونفصح عنها ونحتفظ بها ونحميها عند وصولك إلى موقع Geofleet.ai أو تطبيقات الويب أو تطبيقات الجوال أو واجهات برمجة التطبيقات أو التكاملات أو الخدمات ذات الصلة (مجتمعةً، «الخدمات») أو استخدامك لها.',
      'باستخدامك للخدمات، فإنك تقر بالممارسات الموضحة في سياسة الخصوصية هذه.',
    ],
    sections: {
      informationWeCollect: {
        title: '1. المعلومات التي نجمعها',
        intro: 'حسب كيفية استخدامك للخدمات، قد نجمع فئات المعلومات التالية.',
        account: {
          title: '1.1 معلومات الحساب والملف الشخصي',
          intro: 'قد يشمل ذلك:',
          items: [
            'الاسم',
            'عنوان البريد الإلكتروني',
            'رقم الهاتف',
            'اسم الشركة أو المؤسسة',
            'المسمى الوظيفي',
            'بيانات اعتماد الحساب ومعلومات المصادقة',
            'تفضيلات المستخدم',
            'معلومات أخرى تُقدَّم طوعًا أثناء تسجيل الحساب أو إدارته',
          ],
        },
        delivery: {
          title: '1.2 معلومات التوصيل والتشغيل',
          intro: 'حسب الميزات المستخدمة، قد نعالج:',
          items: [
            'معلومات التوصيل والطلبات',
            'معلومات العملاء والمستلمين',
            'عناوين التوصيل',
            'معلومات السائقين',
            'معلومات المركبات',
            'مواقع السائقين والمركبات',
            'المسارات والرحلات',
            'حالة التوصيل',
            'إثبات التسليم',
            'التوقيعات الإلكترونية',
            'كلمة المرور لمرة واحدة ومعلومات التحقق',
            'معلومات عداد المسافات',
            'معلومات السياج الجغرافي',
            'الملاحظات والسجلات التشغيلية',
            'معلومات أخرى يقدّمها العملاء أو المستخدمون عبر الخدمات',
          ],
        },
        device: {
          title: '1.3 معلومات الجهاز والمعلومات التقنية',
          intro: 'قد نجمع تلقائيًا:',
          items: [
            'عنوان IP',
            'نوع المتصفح',
            'نظام التشغيل',
            'نوع الجهاز',
            'معرّفات الجهاز',
            'معلومات السجلات',
            'معلومات التطبيق',
            'موقع تقريبي مستمد من معلومات تقنية حيثما ينطبق',
            'معلومات الاستخدام والتفاعل',
          ],
        },
        payment: {
          title: '1.4 معلومات الدفع والفوترة',
          intro: 'حيثما ينطبق، قد نعالج:',
          items: [
            'معلومات الفوترة',
            'معلومات الاشتراك',
            'معلومات المعاملات',
            'حالة الدفع',
          ],
          note:
            'قد تتم معالجة معلومات بطاقة الدفع مباشرةً من قبل مزودي دفع من جهات خارجية. ولا نخزّن بالضرورة معلومات بطاقة الدفع الكاملة على أنظمتنا.',
        },
        communications: {
          title: '1.5 الاتصالات',
          intro: 'قد نجمع المعلومات الواردة في:',
          items: [
            'طلبات الدعم',
            'رسائل البريد الإلكتروني',
            'الملاحظات',
            'اتصالات الخدمة',
            'اتصالات أخرى مع Geofleet',
          ],
        },
      },
      googleWorkspace: {
        title: '2. بيانات Google Workspace وGoogle Sheets',
        intro: [
          'توفر Geofleet تكاملاً اختياريًا مع Google Workspace يتيح للمستخدمين المصرح لهم استيراد المعلومات من Google Sheets إلى Geofleet.',
          'عند ربط مستخدم لحساب Google بـ Geofleet، نصل فقط إلى معلومات Google Workspace اللازمة لتوفير وظيفة استيراد Google Sheets التي يطلبها المستخدم.',
          'يستخدم التكامل أذونات واجهة برمجة تطبيقات Google التالية:',
        ],
        drive: {
          title: 'بيانات تعريف Google Drive — drive.metadata.readonly',
          paragraphs: [
            'تستخدم Geofleet وصولاً للقراءة فقط إلى بيانات تعريف Google Drive لاكتشاف الملفات المتاحة في Google Drive الخاص بالمستخدم وإدراجها، بما في ذلك Google Sheets.',
            'يتيح ذلك لـ Geofleet تحديد معلومات مثل:',
          ],
          items: [
            'اسم جدول البيانات',
            'معرّف الملف',
            'نوع الملف',
            'بيانات تعريف أخرى ذات صلة ضرورية لتحديد جدول البيانات',
          ],
          closing: [
            'يُستخدم هذا الإذن للسماح للمستخدم باختيار Google Sheet الذي يريد استخدامه.',
            'لا تستخدم Geofleet هذا الإذن لإنشاء ملفات في Google Drive الخاص بالمستخدم أو تعديلها أو حذفها.',
          ],
        },
        sheets: {
          title: 'Google Sheets للقراءة فقط — spreadsheets.readonly',
          paragraphs: [
            'بعد أن يختار المستخدم جدول بيانات، تستخدم Geofleet وصولاً للقراءة فقط لقراءة محتويات Google Sheet المحدد والورقة/علامة التبويب المختارة.',
            'تُحمَّل المعلومات إلى واجهة الاستيراد في Geofleet حتى يتمكن المستخدم من:',
          ],
          numbered: [
            'مراجعة معلومات جدول البيانات.',
            'اختيار الورقة/علامة التبويب المناسبة.',
            'ربط أعمدة جدول البيانات بحقول Geofleet.',
            'إكمال الاستيراد المطلوب.',
          ],
          closing: ['لا تعدّل Geofleet بيانات Google Sheets الخاصة بالمستخدم ولا تحذفها.'],
        },
      },
      googleProcessing: {
        title: '3. معالجة بيانات Google Workspace وتخزينها',
        paragraphs: [
          'تُعالَج معلومات Google Workspace التي يتم الوصول إليها عبر التكامل فقط لتوفير وظيفة استيراد Google Sheets التي يطلبها المستخدم والوظائف ذات الصلة في Geofleet.',
          'لا يُحتفظ بنسخة منفصلة من جدول بيانات Google المصدر ومحتوياته في الواجهة الخلفية لـ Geofleet كجزء من عملية استيراد Google Sheets.',
          'عندما يستورد المستخدم معلومات عمدًا إلى Geofleet، قد تصبح المعلومات الناتجة جزءًا من حساب Geofleet الخاص بالمستخدم وقد تُخزَّن كبيانات تشغيلية لـ Geofleet.',
          'على سبيل المثال، إذا استورد مستخدم سجلات سائقين من Google Sheet، فقد تُخزَّن معلومات السائقين الناتجة في Geofleet حتى يتمكن المستخدم من استخدامها وإدارتها عبر الخدمات.',
          'تُعالَج هذه المعلومات المستوردة وفقًا لسياسة الخصوصية هذه ومتطلبات التعاقد والاحتفاظ بالبيانات المعمول بها.',
          'لا تستخدم Geofleet بيانات Google Workspace للإعلان أو وساطة البيانات أو البيع لأطراف ثالثة.',
        ],
      },
      googleLimitedUse: {
        title: '4. الاستخدام المحدود لخدمات واجهة برمجة تطبيقات Google',
        paragraphs: [
          'يلتزم استخدام Geofleet للمعلومات المستلمة من واجهات برمجة تطبيقات Google بسياسة بيانات مستخدم خدمات واجهة برمجة تطبيقات Google، بما في ذلك متطلبات الاستخدام المحدود (Limited Use).',
          'لا تبيع Geofleet بيانات مستخدمي Google.',
          'لا تُستخدم بيانات Google Workspace التي يتم الحصول عليها عبر واجهات برمجة تطبيقات Google لإنشاء أو تدريب أو تحسين نماذج ذكاء اصطناعي أو تعلم آلي عامة أو أساسية.',
          'لا تنقل Geofleet بيانات Google Workspace إلى خدمات ذكاء اصطناعي أو تعلم آلي تابعة لأطراف ثالثة بغرض تدريب نماذجها أو تحسينها.',
          'تُستخدم بيانات Google Workspace فقط للوظائف المواجهة للمستخدم الموضحة في سياسة الخصوصية هذه وللأغراض المسموح بها بموجب سياسات خدمات واجهة برمجة تطبيقات Google المعمول بها.',
        ],
      },
      howWeUse: {
        title: '5. كيف نستخدم المعلومات',
        intro: 'قد نستخدم المعلومات التي نجمعها عبر الخدمات من أجل:',
        items: [
          'توفير الخدمات وتشغيلها.',
          'إنشاء حسابات المستخدمين وإدارتها.',
          'معالجة الطلبات والتوصيلات والمسارات والرحلات وسير العمل التشغيلي.',
          'توفير التكاملات والوظائف المطلوبة.',
          'معالجة عمليات الاستيراد التي يبدأها المستخدم.',
          'تقديم دعم العملاء.',
          'التواصل مع المستخدمين بشأن الخدمات.',
          'معالجة الاشتراكات والمدفوعات.',
          'صيانة الخدمات وتأمينها واستكشاف أخطائها وإصلاحها.',
          'اكتشاف ومنع الاحتيال وإساءة الاستخدام والوصول غير المصرح به.',
          'مراقبة أداء النظام وموثوقيته.',
          'تحليل استخدام الخدمات.',
          'تحسين وظائف الخدمات وتجربة المستخدم.',
          'الامتثال للالتزامات القانونية المعمول بها.',
          'إنفاذ شروط الخدمة وغيرها من الاتفاقيات المعمول بها.',
        ],
        note:
          'تُستخدم المعلومات التي يتم الحصول عليها عبر واجهات برمجة تطبيقات Google Workspace فقط للأغراض المسموح بها بموجب سياسة بيانات مستخدم خدمات واجهة برمجة تطبيقات Google المعمول بها ومتطلبات الاستخدام المحدود.',
      },
      aiMl: {
        title: '6. الذكاء الاصطناعي والتعلم الآلي',
        paragraphs: [
          'قد توفر Geofleet وظائف مدعومة بالذكاء الاصطناعي أو الأتمتة أو التحليلات أو التوصيات أو دعم القرار كجزء من الخدمات.',
          'عند استخدامك مساعد ذكاء اصطناعي ضمن الخدمات، مثل Copilot في GeoFleet Lite، نخزّن رسائلك وردود المساعد مع حساب مؤسستك. نستخدمها لعرض سجل محادثاتك على أي جهاز، ولتحسين ميزات الذكاء الاصطناعي في Geofleet وتدريبها. لا تُضمَّن بيانات Google Workspace مطلقًا. يمكن لمؤسستك أن تطلب منا حذف هذا السجل بالتواصل مع الدعم.',
          'لا تُستخدم بيانات Google Workspace التي يتم الحصول عليها عبر واجهات برمجة تطبيقات Google لتدريب أو ضبط أو إنشاء أو تحسين نماذج ذكاء اصطناعي/تعلم آلي عامة أو أساسية.',
          'كما لا تُنقل بيانات Google Workspace إلى مزودي ذكاء اصطناعي/تعلم آلي من أطراف ثالثة بغرض تدريب نماذجهم أو تحسينها.',
          'تخضع أي وظيفة ذكاء اصطناعي أو أتمتة تتضمن معلومات تم الحصول عليها عبر واجهات برمجة تطبيقات Google Workspace للقيود والمتطلبات الموضحة في سياسة الخصوصية هذه وسياسات Google المعمول بها.',
        ],
      },
      sharing: {
        title: '7. المشاركة والإفصاح',
        intro: 'قد نفصح عن المعلومات في الظروف التالية.',
        serviceProviders: {
          title: 'مزودو الخدمات',
          paragraphs: [
            'قد نستخدم مزودي خدمات موثوقين من أطراف ثالثة لمساعدتنا في استضافة الخدمات وتشغيلها وتأمينها وصيانتها وتوفيرها.',
            'قد يعالج هؤلاء المزودون المعلومات نيابةً عنا ويُتوقع منهم استخدام هذه المعلومات فقط للخدمات التي يقدمونها لـ Geofleet وبموجب التزامات تعاقدية وأمنية مناسبة.',
          ],
        },
        legal: {
          title: 'المتطلبات القانونية',
          intro: 'قد نفصح عن المعلومات عندما يكون ذلك ضروريًا بشكل معقول من أجل:',
          items: [
            'الامتثال للقانون المعمول به أو للإجراءات القانونية.',
            'الرد على الطلبات المشروعة من السلطات الحكومية.',
            'حماية حقوق أو ممتلكات أو سلامة Geofleet أو مستخدمينا أو الآخرين.',
            'اكتشاف الاحتيال أو حوادث الأمن أو منعها أو التحقيق فيها.',
          ],
        },
        business: {
          title: 'المعاملات التجارية',
          paragraphs: [
            'قد تُنقل المعلومات كجزء من عملية دمج أو استحواذ أو تمويل أو إعادة هيكلة أو بيع أصول أو معاملة شركات مماثلة، وفقًا للمتطلبات القانونية المعمول بها.',
          ],
        },
        authorization: {
          title: 'بموافقتك',
          paragraphs: [
            'قد نفصح عن المعلومات عندما تكون قد فوّضتنا أو وجّهتنا تحديدًا للقيام بذلك.',
            'لا نبيع المعلومات الشخصية لأغراض التسويق من طرف ثالث.',
            'لا نوفر بيانات Google Workspace لأطراف ثالثة للإعلان أو البيع أو وساطة البيانات أو تدريب نماذج ذكاء اصطناعي/تعلم آلي عامة أو أساسية.',
          ],
        },
      },
      googleAuth: {
        title: '8. تفويض Google وإلغاؤه',
        paragraphs: [
          'عند ربط حساب Google الخاص بك بـ Geofleet، فإنك تفوّض Geofleet بالوصول إلى معلومات Google Workspace الموضحة أثناء عملية تفويض Google.',
          'يمكنك إلغاء تفويض Google الخاص بـ Geofleet في أي وقت عبر إعدادات حساب Google أو الوظائف المتاحة في Geofleet.',
          'بعد إلغاء التفويض، لن تتمكن Geofleet بعد ذلك من الوصول إلى معلومات Google Workspace باستخدام التفويض الملغى.',
          'إلغاء تفويض Google لا يحذف تلقائيًا المعلومات التي سبق أن استوردتها عمدًا إلى Geofleet.',
          'تظل بيانات Geofleet المستوردة سابقًا خاضعة لإجراءات الاحتفاظ والحذف المعمول بها لدى Geofleet.',
        ],
      },
      retention: {
        title: '9. الاحتفاظ بالبيانات',
        intro: 'نحتفظ بالمعلومات طالما كان ذلك ضروريًا بشكل معقول من أجل:',
        items: [
          'توفير الخدمات.',
          'الحفاظ على حسابات العملاء.',
          'الوفاء بالالتزامات التعاقدية.',
          'تقديم دعم العملاء.',
          'تلبية المتطلبات القانونية أو المحاسبية أو التنظيمية.',
          'حل النزاعات.',
          'منع الاحتيال وإساءة الاستخدام.',
          'إنفاذ اتفاقياتنا.',
        ],
        paragraphs: [
          'لا يُحتفظ بنسخة منفصلة من جدول بيانات Google المصدر ومحتوياته في الواجهة الخلفية لدينا كجزء من عملية استيراد Google Sheets.',
          'قد تُحتفظ بالمعلومات المستوردة عمدًا إلى Geofleet وفقًا لمتطلبات الحساب والاشتراك والتشغيل والمتطلبات القانونية والتعاقدية المعمول بها.',
          'عندما لم تعد المعلومات مطلوبة بشكل معقول، قد نحذفها أو نجعلها مجهولة المصدر وفقًا لإجراءات الاحتفاظ لدينا والقانون المعمول به.',
        ],
      },
      security: {
        title: '10. الأمان',
        paragraphs: [
          'ننفّذ تدابير تقنية وتنظيمية معقولة مصممة لحماية المعلومات من الوصول أو الاستخدام أو التغيير أو الإفصاح أو الإتلاف غير المصرح به.',
          'حسب الخدمة والبيئة المعمول بهما، قد تشمل الضمانات:',
        ],
        items: [
          'التشفير أثناء النقل.',
          'التشفير في حالة السكون حيثما ينطبق.',
          'ضوابط الوصول.',
          'آليات المصادقة.',
          'أذونات قائمة على الأدوار.',
          'المراقبة والتسجيل.',
          'ضوابط أمان البنية التحتية.',
          'آليات النسخ الاحتياطي والاستعادة.',
          'تقييمات أمنية وضوابط تشغيلية.',
        ],
        note: 'لا يمكن ضمان أن أي طريقة نقل أو معالجة أو تخزين آمنة تمامًا.',
      },
      rights: {
        title: '11. حقوقك وخياراتك',
        intro:
          'حسب القانون المعمول به وموقعك، قد تكون لديك حقوق تتعلق بمعلوماتك الشخصية، بما في ذلك الحق في:',
        items: [
          'الوصول إلى المعلومات التي نحتفظ بها عنك.',
          'طلب تصحيح المعلومات غير الدقيقة.',
          'طلب حذف المعلومات.',
          'طلب تقييد معالجة معينة.',
          'الاعتراض على معالجة معينة.',
          'طلب نقل بعض المعلومات.',
          'سحب الموافقة عندما تستند المعالجة إلى الموافقة.',
          'تقديم شكوى إلى جهة حماية بيانات مختصة.',
        ],
        contactIntro: 'لممارسة الحقوق المعمول بها أو تقديم طلب خصوصية، تواصل معنا على:',
        verify: 'قد نحتاج إلى التحقق من هويتك قبل تلبية بعض الطلبات.',
      },
      cookies: {
        title: '12. ملفات تعريف الارتباط والتقنيات المشابهة',
        intro: 'قد نستخدم نحن ومزودو خدماتنا ملفات تعريف الارتباط وإشارات الويب والبكسل والتخزين المحلي وتقنيات مشابهة من أجل:',
        items: [
          'تشغيل الخدمات.',
          'تذكر التفضيلات.',
          'الحفاظ على المصادقة.',
          'فهم الاستخدام.',
          'تحسين الأداء.',
          'اكتشاف مشكلات الأمان.',
          'تحليل حركة مرور الموقع.',
        ],
        note:
          'يمكنك التحكم في ملفات تعريف الارتباط عبر إعدادات المتصفح. قد يؤثر تعطيل بعض ملفات تعريف الارتباط على توفر أجزاء من الخدمات أو وظائفها.',
      },
      international: {
        title: '13. عمليات نقل البيانات الدولية',
        paragraphs: [
          'قد تعالج Geofleet ومزودو خدماتها المعلومات في بلدان غير البلد الذي تقيم فيه.',
          'حيثما ينطبق، نتخذ خطوات معقولة لضمان خضوع عمليات النقل الدولية للضمانات المناسبة التي يتطلبها القانون المعمول به.',
        ],
      },
      children: {
        title: '14. خصوصية الأطفال',
        paragraphs: [
          'الخدمات مخصصة لمستخدمي الأعمال وليست موجّهة إلى الأفراد دون سن 18 عامًا.',
          'لا نجمع عن علم معلومات شخصية مباشرة من أطفال دون سن 18 عامًا.',
          'إذا كنت تعتقد أن طفلاً قد قدّم لنا معلومات شخصية، فيرجى التواصل معنا على:',
        ],
        closing:
          'سنتخذ خطوات معقولة للتحقيق في هذه المعلومات وحذفها حيثما كان ذلك مناسبًا.',
      },
      thirdParty: {
        title: '15. خدمات الأطراف الثالثة',
        paragraphs: [
          'قد تحتوي الخدمات على روابط إلى مواقع ويب أو تطبيقات أو واجهات برمجة تطبيقات أو خدمات تابعة لأطراف ثالثة أو تكاملات معها.',
          'تخضع خدمات الأطراف الثالثة لشروطها وسياسات الخصوصية الخاصة بها.',
          'لا تتحمل Geofleet مسؤولية ممارسات الخصوصية لخدمات الأطراف الثالثة التي لا تسيطر عليها Geofleet.',
          'عند تفعيل تكامل، ينبغي عليك مراجعة سياسة الخصوصية وشروط مزود الطرف الثالث المعمول بها.',
        ],
      },
      changes: {
        title: '16. التغييرات على سياسة الخصوصية هذه',
        paragraphs: [
          'قد نحدّث سياسة الخصوصية هذه دوريًا لتعكس التغييرات في خدماتنا أو التكنولوجيا أو المتطلبات القانونية أو ممارسات الأعمال.',
          'عند إجراء تغييرات، سنحدّث تاريخ «آخر تحديث» في أعلى سياسة الخصوصية هذه.',
          'حيثما كان ذلك مناسبًا، قد يتم أيضًا إبلاغ التغييرات الجوهرية عبر البريد الإلكتروني أو الخدمات أو وسيلة معقولة أخرى.',
          'يُعد استمرارك في استخدام الخدمات بعد سريان سياسة خصوصية محدَّثة اعترافًا بالسياسة المحدَّثة بالقدر الذي يسمح به القانون المعمول به.',
        ],
      },
      contact: {
        title: '17. تواصل معنا',
        intro:
          'إذا كانت لديك أسئلة أو مخاوف أو طلبات تتعلق بسياسة الخصوصية هذه أو ممارسات الخصوصية لدينا، فيرجى التواصل معنا:',
        company: 'Geofleet.ai',
        emailLabel: 'البريد الإلكتروني:',
        websiteLabel: 'الموقع:',
        website: 'https://geofleet.ai',
      },
    },
  },
};
